import { TradeOrder } from "@/apis";

export const makeOrderbook = (orderbook: TradeOrder[]) => {
    const sellOrders = orderbook.filter((order) => order.sideType === 1);
    const sellLength = sellOrders.length;
    sellOrders.forEach((sellOrder, index) => {
        sellOrder.index = sellLength - index;
    })
    const buyOrders = orderbook.filter((order) => order.sideType === 2).map((order, index) => {
        order.index = index + 1;
        return order;
    });
    return [...sellOrders, ...buyOrders];
}